import React, { useMemo, useState } from 'react'
import { ContractPosition } from '../../../types'

type Props = {
    open: boolean
    theme: string
    rows: ContractPosition[]
    onClose: () => void
    onSelectRows: (rows: ContractPosition[]) => void
}

const ContractPositionAddFromContractPopup: React.FC<Props> = ({
    open,
    theme,
    rows,
    onClose,
    onSelectRows,
}) => {
    const [selectedGuids, setSelectedGuids] = useState<string[]>([])
    const [query, setQuery] = useState('')

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase()
        if (!q) return rows
        return rows.filter((row) =>
            [row.contract_position_name, row.okpd2_code, row.okpd2_name]
                .filter(Boolean)
                .join(' ')
                .toLowerCase()
                .includes(q)
        )
    }, [rows, query])

    if (!open) return null

    return (
        <div className="fixed inset-0 z-50 bg-[#00000050] flex items-center justify-center">
            <div
                className="flex flex-col gap-4 w-[900px] h-[600px] rounded-lg bg-[#e5e5e5] dark:bg-[#262427] p-5 "
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between">
                    <h2 className="text-[16px] text-[#181818] dark:text-[#FFFFFF]">
                        Добавить позиции с договора
                    </h2>
                </div>

                <input
                    type="text"
                    className="form-input px-3"
                    placeholder="Введите Наименование / ОКПД2"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />

                <div className="flex flex-col gap-1 p-1 overflow-auto">
                    <div className="flex flex-col gap-1">
                        {filtered.map((row) => {
                            const checked = selectedGuids.includes(
                                row.guid ?? ''
                            )
                            return (
                                <label
                                    key={row.ordinal_number}
                                    className={`flex flex-row gap-3 w-full min-h-[36px] px-3 py-2 text-[12px] rounded text-left items-center justify-start cursor-pointer ${
                                        checked
                                            ? 'bg-[#ffffff] dark:bg-[#373538] hover:bg-[#ffffff] hover:dark:bg-[#373538]'
                                            : 'bg-[#f6f6f6] dark:bg-[#2a282b] hover:bg-[#ffffff] hover:dark:bg-[#373538]'
                                    } text-[#181818] dark:text-[#FFFFFF]`}
                                >
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedGuids((prev) => [
                                                    ...prev,
                                                    row.guid ?? '',
                                                ])
                                            } else {
                                                setSelectedGuids((prev) =>
                                                    prev.filter(
                                                        (x) => x !== row.guid
                                                    )
                                                )
                                            }
                                        }}
                                    />
                                    <div className="flex flex-col">
                                        <div className="text-sm">
                                            {row.contract_position_name || '-'}
                                        </div>
                                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            {row.okpd2_code
                                                ? `${row.okpd2_code} - ${row.okpd2_name}`
                                                : 'Без ОКПД2'}
                                        </div>
                                    </div>
                                </label>
                            )
                        })}
                    </div>
                </div>

                <div className="flex justify-end gap-2">
                    <button
                        className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                        onClick={() => {
                            setSelectedGuids([])
                            onClose()
                        }}
                    >
                        Отмена
                    </button>
                    <button
                        className="flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] items-center justify-center text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]"
                        disabled={!selectedGuids.length}
                        onClick={() => {
                            onSelectRows(
                                rows.filter((r) =>
                                    selectedGuids.includes(r.guid ?? '')
                                )
                            )
                            setSelectedGuids([])
                            onClose()
                        }}
                    >
                        Добавить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ContractPositionAddFromContractPopup
